import $ from 'jquery'

export default {

  enable () {
    $('.print-button').click((e) => {
      e.preventDefault()
      window.print()
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/print.js